import { IAddress, IGooglePlaceResult } from '../../models';

export const getGoogleAddressComponentByType = (
  googlePlace: IGooglePlaceResult,
  type: string,
  returnKey: 'short_name' | 'long_name' = 'long_name',
): string => {
  const record = googlePlace.address_components.find((component) => (
    component.types.includes(type)
  ));

  return record?.[returnKey] || '';
};

export const getParsedAddressFromGooglePlace = (googlePlace: IGooglePlaceResult): IAddress => {
  const address = [
    getGoogleAddressComponentByType(googlePlace, 'street_number'),
    getGoogleAddressComponentByType(googlePlace, 'route'),
  ].filter(Boolean).join(' ');

  const address2 = getGoogleAddressComponentByType(googlePlace, 'sublocality');
  return {
    address,
    address2,
    state: getGoogleAddressComponentByType(googlePlace, 'locality'),
    city: getGoogleAddressComponentByType(googlePlace, 'administrative_area_level_1'),
    zip: getGoogleAddressComponentByType(googlePlace, 'postal_code'),
    country: getGoogleAddressComponentByType(googlePlace, 'country', 'short_name'),
  };
};
